import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getControlListItems } from '@/api/correspondence/task/control';
import { toThousandsForMates } from '@/filters';
import { json2excel } from '@/util/json2excel';
export default {
  name: 'correspondence-control-list-detail',
  props: {
    taskId: {
      required: true
    },
    id: {
      required: true
    }
  },
  data: function data() {
    return {
      exportType: false,
      loading: false,
      currentTableData: [],
      accountSums: [],
      maxHeight: 0,
      timer: null,
      baseForm: {
        code: undefined,
        type: undefined,
        cusName: undefined,
        perior: undefined
      }
    };
  },
  methods: {
    export2excel: function export2excel() {
      var _this = this;
      var name = "".concat(this.baseForm.code, "-").concat(this.baseForm.cusName, "-").concat(this.baseForm.type, "-").concat(this.baseForm.perior, ".xlsx");
      var accountSums = this.accountSums;
      // const accountSumsHeader = []
      // const accountSumsLength = accountSums.length
      // for (let i = 0; i < accountSumsLength; i++) {
      //   accountSumsHeader.push('null')
      // }
      var accountSumsHeader2 = accountSums.map(function (item) {
        return item.c12AccountName;
      });
      // accountSumsHeader2.push('样本类型')
      var excelHeader = [['函证状态', '函证编号', '函证对象全称(企业/个人)', '所属子公司', '截止日期', '样本类型', '被函证对象发函地址', '函证收件人', '收件人联系电话', '收件人备用电话', '收件人职位', '工商注册地址', '距离', '地址核对结论', '核对过程说明', '发函方式', '发函快递公司', '发函邮寄单号', '发函/跟函人', '发函/跟函日期', '发函/跟函地点', '发函/跟函过程描述', '回函方式', '回函快递公司', '回函邮寄单号', '回函发出地址', '回函人', '回函签收日期', '回函函证状态', '回函函证结论', '回函地址核验', '地址距离', '项目组-地址异常检查说明', '项目组-函证异常/结论不符检查说明'].concat(_toConsumableArray(accountSumsHeader2))];
      // const accountSumsHeader2Length = accountSumsHeader2.length + 2
      // const sendHeader2Length = sendHeader2.length + accountSumsHeader2Length
      // const backHeader2Length = backHeader2.length + sendHeader2Length
      var merge = [
        // { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
        // { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } },
        // { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } },
        // { s: { r: 0, c: 3 }, e: { r: 0, c: accountSumsHeader2Length } },
        // { s: { r: 0, c: accountSumsHeader2Length + 1 }, e: { r: 0, c: sendHeader2Length } },
        // { s: { r: 0, c: sendHeader2Length + 1 }, e: { r: 0, c: backHeader2Length } }
      ];
      var currentTableData = this.currentTableData;
      if (!this.exportType) {
        currentTableData = currentTableData.filter(function (item) {
          return item.confirmation.c02Status === '已回函' || item.confirmation.c02Status === '已发函';
        });
      }
      var tableData = currentTableData.map(function (item) {
        var confirmation = item.confirmation;
        var accountSumItem = accountSums.map(function (sub) {
          return _this.getAccountVal(item, sub.c12AccountName);
        });
        accountSumItem.push(confirmation.c02SampleType);
        return [confirmation.c02Status, confirmation.c02ConfirmCode, "".concat(confirmation.c03CusName).concat(confirmation.c03CusType ? "(".concat(confirmation.c03CusType, ")") : ''), confirmation.c02AuditCompany, confirmation.c02Perior, confirmation.c02SampleType, confirmation.c02ObjAddress, confirmation.c02ObjStaff, confirmation.c02ObjMobile, confirmation.c02ObjTel, confirmation.c02ObjPosition, confirmation.c03CorrectAddress, _this.km(confirmation.c02CheckDistance), confirmation.c02CheckConclusion, confirmation.c02CheckProcess, confirmation.c02SendType, confirmation.c02SendCompany, confirmation.c02SendNumber, confirmation.c02SendStaff, _this.$options.filters.date(confirmation.c02SendDate, 'yyyy-MM-dd'), confirmation.c02SendAddress, confirmation.c02SendProcess, confirmation.c02BackType, confirmation.c02BackCompany, confirmation.c02BackNumber, confirmation.c02BackAddress, confirmation.c02BackSendName, _this.$options.filters.date(confirmation.c02BackConfirmActualDate, 'yyyy-MM-dd'), confirmation.c02BackConfirmValid, confirmation.c02BackConfirmConclusion, confirmation.c02BackAddressCheck, _this.km(confirmation.c02BackAddressDistance), confirmation.c02BackAddressFllow, confirmation.c02BackAddressReStatus].concat(_toConsumableArray(accountSumItem));
      });
      var sum1 = [];
      var sum2 = [];
      var sum3 = [];
      var sum4 = [];
      var sum5 = [];
      sum1 = accountSums.map(function (sub) {
        return toThousandsForMates(sub.c12AccountSum);
      });
      sum2 = accountSums.map(function (sub) {
        return toThousandsForMates(sub.c12ConfirmSendSum);
      });
      sum3 = accountSums.map(function (sub) {
        return toThousandsForMates(sub.c12ConfirmBackSum);
      });
      sum4 = accountSums.map(function (sub) {
        return "".concat(_this.toFixed(sub.c12ConfirmSendRatio), "%");
      });
      sum5 = accountSums.map(function (sub) {
        return "".concat(_this.toFixed(sub.c12ConfirmBackRatio), "%");
      });
      var excelHeaderLength = excelHeader[0].length;
      var footerLen = excelHeaderLength - accountSumsHeader2.length - 1;
      var footItem = [];
      for (var i = 0; i < footerLen; i++) {
        footItem.push(null);
      }
      var footer = [['账面期末余额'].concat(footItem, _toConsumableArray(sum1)), ['发出函证金额汇总'].concat(footItem, _toConsumableArray(sum2)), ['回函函证金额汇总'].concat(footItem, _toConsumableArray(sum3)), ['发函金额占比'].concat(footItem, _toConsumableArray(sum4)), ['回函金额占比'].concat(footItem, _toConsumableArray(sum5))];
      // const footerLength = footer[0].length
      // for (let i = footerLength; i < excelHeaderLength; i++) {
      //   footer[0].push(null)
      //   footer[1].push(null)
      //   footer[2].push(null)
      //   footer[3].push(null)
      //   footer[4].push(null)
      // }
      var line = [];
      for (var _i = 0; _i < excelHeaderLength; _i++) {
        line.push(null);
      }
      var data = [].concat(excelHeader, _toConsumableArray(tableData), [line], footer);
      json2excel(data, name, merge);
    },
    getInfo: function getInfo() {
      var params = this.$route.query.params;
      if (params) {
        this.baseForm = JSON.parse(params);
      }
    },
    getAccountVal: function getAccountVal(row, name) {
      var confirmData = row.confirmData;
      var res = confirmData.find(function (item) {
        return item.c21Account === name;
      });
      if (res) {
        return toThousandsForMates(res.c21Amount);
      }
      return '';
    },
    getList: function getList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, data, confirmations, accountSums;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this2.loading = true;
              _context.n = 1;
              return _this2.$awaitTo(getControlListItems(_this2.taskId, _this2.id, {}));
            case 1:
              _yield$_this2$$awaitT = _context.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 2);
              err = _yield$_this2$$awaitT2[0];
              data = _yield$_this2$$awaitT2[1];
              _this2.loading = false;
              if (!err) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              if (data) {
                confirmations = data.confirmations, accountSums = data.accountSums;
                _this2.currentTableData = confirmations;
                _this2.accountSums = accountSums;
              }
              if (!(_this2.maxHeight !== 0)) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              _this2.$nextTick(function () {
                _this2.getHeight();
              });
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    toFixed: function toFixed(num) {
      if (!isNaN(parseFloat(num))) {
        return (num * 100).toFixed(2);
      }
      return num;
    },
    getSummaries: function getSummaries(param) {
      var _this3 = this;
      var columns = param.columns,
        data = param.data;
      var sums = ['', '账面期末余额\n发出函证金额汇总\n回函函证金额汇总\n发函金额占比\n回函金额占比'];
      columns.forEach(function (column, index) {
        var res = _this3.accountSums.find(function (item) {
          return column.label === item.c12AccountName;
        });
        if (res) {
          sums[index] = "".concat(toThousandsForMates(res.c12AccountSum), "\n").concat(toThousandsForMates(res.c12ConfirmSendSum), "\n").concat(toThousandsForMates(res.c12ConfirmBackSum), "\n").concat(_this3.toFixed(res.c12ConfirmSendRatio), "%\n").concat(_this3.toFixed(res.c12ConfirmBackRatio), "%");
        }
      });
      return sums;
    },
    getHeight: function getHeight() {
      var _this4 = this;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        var body = document.querySelector('.d2-container-full__body');
        _this4.maxHeight = body.scrollHeight - 60;
        _this4.getHeightFlag = true;
      }, 500);
    },
    km: function km(val) {
      if (!val) {
        return '0(m)';
      }
      if (val >= 0 && val < 1000) {
        return "".concat(val, "(m)");
      }
      return "".concat((val / 1000).toFixed(2), "(km)");
    }
  },
  created: function created() {
    this.getInfo();
  },
  mounted: function mounted() {
    this.getList();
  }
};